import { useCatalogResources } from '../../hooks/useCatalogResources';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { AcademyContentCard } from './AcademyContentCard';
import { AcademyContentCardSkeleton } from './AcademyContentCardSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const ITEM_TYPE_TO_CONTAINER_TYPE = {
  COURSE: 'TRACK',
  LESSON: 'LESSON',
  SHORT_VIDEO: 'SHORT_FORM_CONTENT'
};
export const AcademyRecommendations = ({
  section: {
    itemId,
    itemType,
    language
  }
}) => {
  var _ITEM_TYPE_TO_CONTAIN;
  const {
    isMobile
  } = useMediaQuery();
  const {
    resources,
    loading,
    error
  } = useCatalogResources([{
    resourceId: itemId,
    type: (_ITEM_TYPE_TO_CONTAIN = ITEM_TYPE_TO_CONTAINER_TYPE[itemType]) !== null && _ITEM_TYPE_TO_CONTAIN !== void 0 ? _ITEM_TYPE_TO_CONTAIN : itemType,
    language: itemType === 'COURSE' || itemType === 'LESSON' ? language === null || language === void 0 ? void 0 : language.toLowerCase() : undefined
  }]);
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      marginBlockStart: "400",
      marginBlockEnd: isMobile ? '400' : undefined,
      children: /*#__PURE__*/_jsx(AcademyContentCardSkeleton, {})
    });
  }
  if (error || !(resources !== null && resources !== void 0 && resources.length)) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    marginBlockStart: "400",
    marginBlockEnd: isMobile ? '400' : undefined,
    children: /*#__PURE__*/_jsx(AcademyContentCard, {
      model: resources[0]
    })
  });
};